export default __webpack_public_path__ + "static/analysis-403e2b7370232aa1c3478c907b22a1d9.png";